module.exports = __webpack_public_path__ + "fonts/VetoSans-Light.71e9fd9b.woff2";